import { render, staticRenderFns } from "./RevisionSolicitudReclamacion.html?vue&type=template&id=166d7cef&external"
import script from "./RevisionSolicitudReclamacion.vue?vue&type=script&lang=js"
export * from "./RevisionSolicitudReclamacion.vue?vue&type=script&lang=js"
import style0 from "./RevisionSolicitudReclamacion.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports